import { AxiosResponse } from 'axios';
import { SET_ZMANIMS_N, SET_ZMANIM_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ZMANIM_N_ISLOADING,
  DELETE_ZMANIM_N,
  EDIT_ZMANIM_N,
  GET_ZMANIM_N,
  GET_ZMANIMS_N,
  REGISTER_ZMANIM_N,
  TOGGLE_ZMANIM_N_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Zmanim_N from '@/services/zmanim_N';
import { Module } from 'vuex';
import { EditZmanim_N, RegisterZmanim_N, GetZmanim_N } from '@/dtos/zmanim_N.dto';

const zmanim_N: Module<any, {}> = {
  state: {
    zmanim_N: {
      data: null,
      isLoading: false,
    },
    zmanims_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    zmanim_N: (state: { zmanim_N: any }) => state.zmanim_N,
    zmanims_N: (state: { zmanims_N: any }) => state.zmanims_N,
  },
  mutations: {
    [SET_ZMANIM_N]: (
      state: { zmanim_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanim_N.data = payload.data) : null;
      state.zmanim_N.isLoading = payload.isLoading;
    },
    [SET_ZMANIMS_N]: (
      state: { zmanims_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanims_N.data = payload.data) : null;
      state.zmanims_N.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_ZMANIM_N]: async ({ commit }: any, payload: RegisterZmanim_N) => {
      commit(SET_ZMANIM_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.registerZmanim_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_N, { isLoading: false });
        return false;
      }
    },
    [GET_ZMANIMS_N]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIMS_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.getZmanims_N(
        payload as GetZmanim_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIMS_N, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_ZMANIMS_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIMS_N, { isLoading: false });
        return false;
      }
    },
    [GET_ZMANIM_N]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIM_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.getZmanims_N(
        payload as GetZmanim_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_N, {
            data: result.data.data?.[0] ?? null,
            isLoading: false,
          });
          return result.data.data?.[0];
        }
        commit(SET_ZMANIM_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_N, { isLoading: false });
        return false;
      }
    },
    [EDIT_ZMANIM_N]: async ({ commit }: any, payload: EditZmanim_N) => {
      commit(SET_ZMANIM_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.editZmanim_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_N, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_ZMANIM_N_IS_ACTIVE]: async ({ commit, state }: any, payload: { id: string }) => {
      commit(SET_ZMANIM_N, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.toggleZmanim_NIsActive(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.zmanims_N?.data && Array.isArray(state.zmanims_N.data)) {
            state.zmanims_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.zmanims_N.data[index].isActive = result.data.data.isActive;
            }
          }
          commit(SET_ZMANIM_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_N, { isLoading: false });
        return false;
      }
    },
    [DELETE_ZMANIM_N]: async ({ commit }: any, payload: string) => {
      commit(SET_ZMANIM_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim_N.deleteZmanim_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ZMANIM_N_ISLOADING]: ({ commit }) => {
      commit(SET_ZMANIM_N, { isLoading: false });
      commit(SET_ZMANIMS_N, { isLoading: false });
    },
  },
};

export default zmanim_N;
